export default __webpack_public_path__ + "static/media/0xc3fdbadc7c795ef1d6ba111e06ff8f16a20ea539.2eb755ba.png";